import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { ProductCard } from "./Home";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";

export default function Catalog() {
  const { category } = useParams();
  const [sp] = useSearchParams();
  const q = sp.get("q") || "";
  const [products, setProducts] = useState([]);
  const [sort, setSort] = useState("popularity");
  const [cats, setCats] = useState([]);
  const [settings, setSettings] = useState({ show_sort_dropdown: true, show_category_filters: true });

  useEffect(() => {
    api.get("/categories").then(r => setCats(r.data)).catch(()=>{});
    api.get("/storefront/settings").then(r => setSettings(r.data)).catch(()=>{});
  }, []);
  useEffect(() => {
    const params = new URLSearchParams();
    if (category) params.set("category", category);
    if (q) params.set("q", q);
    params.set("sort", sort);
    api.get(`/products?${params.toString()}`).then(r => setProducts(r.data)).catch(()=>{});
  }, [category, q, sort]);

  const cat = cats.find(c => c.slug === category);
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
      <div className="mb-8">
        <div className="uppercase text-xs tracking-[0.3em] text-[#8B7355]">Shop</div>
        <h1 className="font-serif-display text-5xl mt-2">{cat?.name || (q ? `Results for "${q}"` : "All products")}</h1>
        <div className="text-stone-500 text-sm mt-2" data-testid="product-count">{products.length} products</div>
      </div>
      {(settings.show_category_filters || settings.show_sort_dropdown) && (
      <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
        {settings.show_category_filters ? (
          <div className="flex flex-wrap gap-2">
            <a href="/shop" className={`px-4 py-1.5 rounded-full text-sm border ${!category?"bg-[#3B2F2F] text-white border-[#3B2F2F]":"bg-white border-stone-200"}`}>All</a>
            {cats.map(c => (
              <a key={c.slug} href={`/shop/${c.slug}`} data-testid={`filter-cat-${c.slug}`}
                className={`px-4 py-1.5 rounded-full text-sm border ${category===c.slug?"bg-[#3B2F2F] text-white border-[#3B2F2F]":"bg-white border-stone-200 hover:bg-stone-50"}`}>
                {c.name}
              </a>
            ))}
          </div>
        ) : <div/>}
        {settings.show_sort_dropdown && (
          <Select value={sort} onValueChange={setSort}>
            <SelectTrigger className="w-44" data-testid="sort-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="popularity">Most popular</SelectItem>
              <SelectItem value="newest">Newest</SelectItem>
              <SelectItem value="price_asc">Price: Low → High</SelectItem>
              <SelectItem value="price_desc">Price: High → Low</SelectItem>
              <SelectItem value="rating">Best rated</SelectItem>
            </SelectContent>
          </Select>
        )}
      </div>
      )}
      <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {products.map(p => <ProductCard key={p.product_id} p={p} />)}
      </div>
      {products.length === 0 && <div className="text-center py-16 text-stone-500">No products found.</div>}
    </div>
  );
}
